import 'ui-theme/plugins/slide/js/slide';

(function () {
    const slide = UX.slide;

    slide.init = function (e) {
        slide.$slide =
            '<div class="w-slide"><div class="w-slide_head"><span class="w-slide__back"><i class=" icon-arrow_l" aria-hidden="true"></i>' +
            slide.backLabel +
            '</span><span class="w-slide__title"></span></span></div><div class="w-slide__content"></div></div>';

        slide.$elements = $(slide.$slide);
        slide.displaySlideHtmlToPage();

        slide.$contents = slide.$elements.find('.w-slide__content');
        slide.$slideinfo = slide.$elements.find('.w-slide__title');
        slide.$back = slide.$elements.find('.w-slide__back');
        slide.$toggle = $('.w-slide__btn');

        slide.elementvPort = slide.vPort;
        slide.vPort = [];

        slide.customViewPorts();

        slide.$toggle.each(function (index) {
            slide.check.viewPort($(this), index);
            slide.responsive(index);
        });

        slide.additionalInitialization();
        slide.control();
        slide.additionalControls();
        if (typeof facetDateChart != 'undefined') {
            facetDateChart.control(); /*eslint-disable-line*/
        }

        if (UX.utils && UX.utils.isRTL()) {
            slide.isRTL = true;
        }
    };
})();
